
import * as vercelRuntime$yTHX7nbnzcfjNU90dy34THn0Ca_SJJHSbkQI68KQDj4 from '/vercel/path0/node_modules/.pnpm/@nuxt+image@1.10.0/node_modules/@nuxt/image/dist/runtime/providers/vercel'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vercel",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['vercel']: { provider: vercelRuntime$yTHX7nbnzcfjNU90dy34THn0Ca_SJJHSbkQI68KQDj4, defaults: {} }
}
        